import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "popover-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_tour_step = _resolveComponent("el-tour-step")!
  const _component_el_tour = _resolveComponent("el-tour")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_button, {
      type: "primary",
      onClick: _ctx.startTour,
      disabled: !_ctx.tourAvailable
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('concordanceSearchTour.tourName')), 1)
      ]),
      _: 1
    }, 8, ["onClick", "disabled"]),
    _createVNode(_component_el_popover, {
      visible: _ctx.tourPopover,
      "virtual-ref": _ctx.popoverTarget,
      "virtual-triggering": "",
      placement: "bottom",
      width: 400,
      "popper-class": "concordance-tour-popover"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('concordanceSearchTour.openSearch')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('concordanceSearchTour.openSearchDescription')), 1),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.continueTour
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('generic.next')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "virtual-ref"]),
    _createVNode(_component_el_tour, {
      modelValue: _ctx.tourStart,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tourStart) = $event)),
      "target-area-clickable": false
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tourSteps, (step) => {
          return (_openBlock(), _createBlock(_component_el_tour_step, {
            key: step.id,
            target: step.target,
            title: _ctx.$t(step.title),
            description: _ctx.$t(step.description)
          }, null, 8, ["target", "title", "description"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}